import { Injectable } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Location } from '@angular/common';

type State = { name: string; params: any };

@Injectable()
export class NavigateBackService {
  private history: State[] = [];

  constructor(
    private $state: StateService,
    private location: Location
  ) {}

  pushState(state: State) {
    this.history.push(state);
  }

  public goBack(toState?, toParams?): void {
    const currentStateDefinition = this.$state.get(this.$state.current.name);
    const defaultPreviousState = currentStateDefinition?.data?.defaultBackState;

    this.history.pop();

    if (this.history.length > 0) {
      // Use browser's back method
      this.location.back();
    } else if (toState) {
      // Take user to passed back state in parameter (fallback)
      this.$state.go(toState, toParams);
    } else if (defaultPreviousState?.name) {
      // Take user to preferred back state for the current state
      this.$state.go(defaultPreviousState.name, defaultPreviousState.params);
    } else {
      // Fallback to /dashboard
      this.$state.go('dashboard');
    }
  }
}
